module.exports = __webpack_public_path__ + "img/Porto Apartment - 14 of 85.b4342269.jpeg";